import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "../../../../../../../redux/store";
import type { ReviewedFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveReviewedFundingRequests = createAsyncThunk<ReviewedFundingRequestVM[], void, { extra: Partial<Dependencies> }>(
  "fundingRequests/retrieveReviewedFundingRequests",
  async (_: void, { extra: { adminRepository } }) => {
    const requests = await adminRepository!.getAll({ status: ["reviewed"] });
    const response: ReviewedFundingRequestVM[] = [];
    for (const r of requests) {
      if (r.status === "reviewed") {
        response.push(r);
      }
    }
    return response;
  },
);
